import { FC, type JSX } from 'react'
import { useMedia } from 'react-use'

import { SwiperImageSlider } from '../../../../../brunswick/components/SwiperImageSlider'
import { IconBadge, IconBadgePlacement } from '../../../../../types/graphql'
import { GalleryImageStateContainer } from '../contexts/GalleryImageStateContainer'

export interface ProductAssetsSectionProps {
  fitModelCaption: JSX.Element | null
  iconBadge?: IconBadge
  iconBadgePlacement?: IconBadgePlacement
  productGroupStyle?: string
  title?: string
}

export const ProductAssetsSection: FC<ProductAssetsSectionProps> = ({
  fitModelCaption,
  iconBadge,
}) => {
  const { allAssets, currentAssetIndex, showImageZoom } = GalleryImageStateContainer.useContainer()
  const shouldDisplayIconBadge = currentAssetIndex === 0

  // TODO: This needs to be CSS based, the server side render can't tell how big the viewport will be ahead of time.
  // So we are rending the wrong visual on SSR most of the time :(
  const showExtraLargeIcon = useMedia(`(min-width: 1100px)`, false)

  return (
    <SwiperImageSlider
      fitModelCaption={fitModelCaption}
      iconBadge={iconBadge}
      shouldDisplayIconBadge={shouldDisplayIconBadge}
      showExtraLargeIcon={showExtraLargeIcon}
      showImageZoom={showImageZoom}
      sliderAssets={allAssets}
    />
  )
}
